module.exports = __webpack_public_path__ + "img/card-image2@2x.96e73605.png";